module.exports = __webpack_public_path__ + "static/media/406.cbd93691.webp";